/* ============================================================
 * QUIZ FLOW · Terramoda
 *
 * Wizard de 7 pasos. Maneja:
 *  - Navegación entre pasos (siguiente/atrás)
 *  - Validación de respuestas
 *  - Persistencia en localStorage (recuperar si refresca)
 *  - Cálculo de talla y ángulo según respuestas
 *  - Redirect final a PDP personalizada O waitlist XS/XL
 *  - Tracking de cada acción (via QuizTracker)
 *
 * Requiere window.QuizTracker (quiz-tracker.js) cargado antes.
 * ============================================================ */

(function() {
  'use strict';

  // ============================================================
  // CONFIGURACIÓN
  // ============================================================
  var STORAGE_KEY = 'quiz_terramoda_state';
  var TOTAL_STEPS = 7;

  // Mapeo peso → talla y bucket numérico
  // 1=<12kg(XS), 2=12-22kg(S), 3=22-40kg(M), 4=40-55kg(L), 5=>55kg(XL)
  var WEIGHT_TO_SIZE = {
    '1': 'XS',
    '2': 'S',
    '3': 'M',
    '4': 'L',
    '5': 'XL'
  };

  // Tallas disponibles en stock
  var IN_STOCK_SIZES = ['S', 'M', 'L'];

  // ============================================================
  // STATE
  // ============================================================
  // Estado caduca tras 30 min de inactividad — evita "vuelves a entrar y te queda en paso 7"
  var STATE_TTL_MS = 30 * 60 * 1000;

  function emptyState() {
    return {
      currentStep: 0,
      answers: {
        dogName: '',
        age: '',           // young / adult / senior
        breed: '',
        breedRisk: '',
        breedSizeHint: '',
        weight: '',        // bucket 1-5
        problem: '',       // PRIMER problema seleccionado (define ángulo)
        problems: [],      // TODOS los problemas seleccionados (multi-select)
        vet: '',
        email: '',
        emailOptIn: true
      },
      startedAt: null,
      updatedAt: null
    };
  }

  function loadState() {
    try {
      var s = localStorage.getItem(STORAGE_KEY);
      if (s) {
        var parsed = JSON.parse(s);
        // Caducidad: si el estado guardado es viejo, descarta y empieza limpio
        if (parsed.updatedAt && (Date.now() - parsed.updatedAt) > STATE_TTL_MS) {
          try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
          return emptyState();
        }
        return parsed;
      }
    } catch (e) {}
    return emptyState();
  }

  function saveState() {
    state.updatedAt = Date.now();
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  function clearState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  var state = loadState();

  // ============================================================
  // DOM HELPERS
  // ============================================================
  var $ = function(sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  // ============================================================
  // PROGRESS BAR
  // ============================================================
  function updateProgress() {
    var fill = $('.quiz-progress__bar-fill');
    var count = $('.quiz-progress__count');
    var back = $('.quiz-progress__back');
    var progress = $('.quiz-progress');

    if (state.currentStep === 0) {
      if (progress) progress.style.display = 'none';
      return;
    } else {
      if (progress) progress.style.display = '';
    }

    var pct = Math.round((state.currentStep / TOTAL_STEPS) * 100);
    if (fill) fill.style.width = pct + '%';
    if (count) count.textContent = state.currentStep + ' / ' + TOTAL_STEPS;
    if (back) back.hidden = (state.currentStep <= 1);
  }

  function fillPlaceholders(str) {
    return (str || '').replace(/\{DOG\}/g, state.answers.dogName || 'tu perro');
  }

  function applyDynamicText() {
    $$('[data-dynamic]').forEach(function(el) {
      var template = el.getAttribute('data-dynamic-template') || el.textContent;
      if (!el.hasAttribute('data-dynamic-template')) {
        el.setAttribute('data-dynamic-template', template);
      }
      el.textContent = fillPlaceholders(template);
    });
  }

  // ============================================================
  // STEP NAVIGATION
  // ============================================================
  function showStep(n) {
    $$('.quiz-step').forEach(function(s) {
      s.setAttribute('data-active', s.getAttribute('data-step') === String(n) ? 'true' : 'false');
    });
    $$('.quiz-intro').forEach(function(s) {
      s.setAttribute('data-active', n === 0 ? 'true' : 'false');
      s.style.display = (n === 0) ? '' : 'none';
    });
    state.currentStep = n;
    saveState();
    updateProgress();
    applyDynamicText();

    if (n > 0 && n <= TOTAL_STEPS) {
      var stepEl = $('.quiz-step[data-step="' + n + '"]');
      var stepName = stepEl ? stepEl.getAttribute('data-step-name') : '';
      QuizTracker.enterStep(n, stepName);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function() {
        var firstInput = stepEl && (stepEl.querySelector('input[type="text"], input[type="email"]') || stepEl.querySelector('.quiz-breed-search'));
        if (firstInput && state.currentStep <= 1) firstInput.focus();
      }, 350);
    }

    refreshNextButtonState();
  }

  function goNext() {
    if (!isCurrentStepValid()) return;
    var stepEl = $('.quiz-step[data-step="' + state.currentStep + '"]');
    var stepName = stepEl ? stepEl.getAttribute('data-step-name') : '';
    var stepValue = getCurrentStepValue();
    QuizTracker.completeStep(state.currentStep, stepName, stepValue);

    if (state.currentStep >= TOTAL_STEPS) {
      finishQuiz();
    } else {
      showStep(state.currentStep + 1);
    }
  }

  function goBack() {
    if (state.currentStep <= 1) return;
    QuizTracker.track('quiz_step_back', {
      from_step: state.currentStep,
      to_step: state.currentStep - 1
    });
    showStep(state.currentStep - 1);
  }

  // ============================================================
  // VALIDACIÓN POR PASO
  // ============================================================
  function isCurrentStepValid() {
    switch (state.currentStep) {
      case 1: return !!(state.answers.dogName && state.answers.dogName.trim().length >= 2);
      case 2: return !!state.answers.age;
      case 3: return !!state.answers.breed;
      case 4: return !!state.answers.weight;
      case 5: return (state.answers.problems && state.answers.problems.length > 0) || !!state.answers.problem;
      case 6: return true; // SKIP permitido: vet siempre opcional
      case 7:
        if (!state.answers.emailOptIn) return true;
        if (!state.answers.email) return true;
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.answers.email);
      default: return false;
    }
  }

  function getCurrentStepValue() {
    var a = state.answers;
    switch (state.currentStep) {
      case 1: return a.dogName;
      case 2: return a.age;
      case 3: return { breed: a.breed, risk: a.breedRisk };
      case 4: return a.weight;
      case 5: return a.problem;
      case 6: return a.vet;
      case 7: return { hasEmail: !!a.email, optIn: a.emailOptIn };
    }
  }

  function refreshNextButtonState() {
    var btn = $('.quiz-step[data-active="true"] .quiz-next');
    if (btn) btn.disabled = !isCurrentStepValid();
  }

  // ============================================================
  // STEP 1 — Dog name
  // ============================================================
  function initStep1() {
    var input = $('.quiz-step[data-step="1"] .quiz-input');
    if (!input) return;
    input.value = state.answers.dogName || '';
    input.addEventListener('input', function() {
      state.answers.dogName = this.value;
      saveState();
      applyDynamicText();
      refreshNextButtonState();
    });
  }

  // ============================================================
  // STEP 2 — Age (3 buttons)
  // STEP 4 — Weight (5 buttons)
  // STEP 5 — Problem (5 buttons)
  // STEP 6 — Vet (5 buttons)
  // Patrón común: quiz-options con data-value
  // ============================================================
  function initOptionButtons() {
    $$('.quiz-step').forEach(function(step) {
      var stepN = parseInt(step.getAttribute('data-step'), 10);
      var field = step.getAttribute('data-field');
      var isMulti = step.getAttribute('data-multi') === 'true';
      if (!field) return;
      var opts = $$('.quiz-option', step);

      // Estado inicial
      if (isMulti) {
        var arr = state.answers.problems || [];
        opts.forEach(function(o) {
          o.setAttribute('aria-pressed', arr.indexOf(o.getAttribute('data-value')) > -1 ? 'true' : 'false');
        });
      } else {
        var current = state.answers[field];
        opts.forEach(function(o) {
          o.setAttribute('aria-pressed', o.getAttribute('data-value') === current ? 'true' : 'false');
        });
      }

      opts.forEach(function(opt) {
        opt.addEventListener('click', function() {
          var val = this.getAttribute('data-value');

          if (isMulti) {
            // MULTI-SELECT: toggle, mantener orden de selección
            var arr = state.answers.problems || [];
            var idx = arr.indexOf(val);
            if (idx > -1) {
              arr.splice(idx, 1);
              this.setAttribute('aria-pressed', 'false');
            } else {
              arr.push(val);
              this.setAttribute('aria-pressed', 'true');
            }
            state.answers.problems = arr;
            // Primer problema = ángulo principal
            state.answers[field] = arr[0] || '';
          } else {
            // SINGLE-SELECT
            state.answers[field] = val;
            opts.forEach(function(o) { o.setAttribute('aria-pressed', 'false'); });
            this.setAttribute('aria-pressed', 'true');
          }

          saveState();
          refreshNextButtonState();

          // Mejora 1: Vista previa de talla tras seleccionar peso
          if (field === 'weight') showSizePreview(val);
        });
      });
    });
  }

  // ============================================================
  // MEJORA 1 — Vista previa de talla tras paso 4
  // ============================================================
  var WEIGHT_LABEL = {
    '1': { size: 'XS', label: 'XS' },
    '2': { size: 'S',  label: 'S' },
    '3': { size: 'M',  label: 'M' },
    '4': { size: 'L',  label: 'L' },
    '5': { size: 'XL', label: 'XL' }
  };
  function showSizePreview(weightBucket) {
    var info = WEIGHT_LABEL[weightBucket];
    if (!info) return;
    var step = $('.quiz-step[data-step="4"]');
    if (!step) return;
    var box = $('.quiz-size-preview', step);
    if (!box) return;
    box.className = 'quiz-size-preview preview--ok';
    var name = state.answers.dogName || 'tu perro';
    box.innerHTML = '<span class="quiz-size-preview__arrow">→</span>' +
                    '<span class="quiz-size-preview__text">Recomendamos talla <strong>' + info.label + '</strong> para ' + escapeHtml(name) + '.</span>';
    box.removeAttribute('hidden');
  }

  // ============================================================
  // STEP 3 — Breed picker (searchable dropdown)
  // ============================================================
  function initStep3() {
    var step = $('.quiz-step[data-step="3"]');
    if (!step) return;
    var search = $('.quiz-breed-search', step);
    var list = $('.quiz-breed-list', step);
    if (!search || !list) return;

    var dataEl = document.getElementById('quiz-breeds-data');
    if (!dataEl) return;
    var breeds = [];
    try { breeds = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function render(filter) {
      filter = (filter || '').toLowerCase().trim();
      var matches = filter
        ? breeds.filter(function(b) { return b.name.toLowerCase().indexOf(filter) > -1; })
        : breeds;

      if (filter && search.value && matches.length < breeds.length) {
        QuizTracker.track('quiz_breed_searched', {
          query: filter,
          results_count: matches.length
        });
      }

      list.innerHTML = '';
      if (matches.length === 0) {
        var empty = document.createElement('li');
        empty.className = 'quiz-breed-item--empty';
        empty.textContent = 'No encontramos esa raza. Selecciona "Otra raza" o "Mestizo".';
        list.appendChild(empty);
        return;
      }
      matches.forEach(function(b) {
        var li = document.createElement('li');
        li.className = 'quiz-breed-item';
        li.setAttribute('data-breed', b.name);
        li.setAttribute('data-size', b.size || '');
        li.setAttribute('data-risk', b.risk || '');
        li.setAttribute('aria-pressed', state.answers.breed === b.name ? 'true' : 'false');

        var name = document.createElement('span');
        name.textContent = b.name;
        li.appendChild(name);

        if (b.risk === 'very-high' || b.risk === 'high') {
          var risk = document.createElement('span');
          risk.className = 'quiz-breed-item__risk';
          risk.setAttribute('data-risk', b.risk);
          risk.textContent = (b.risk === 'very-high') ? 'Predisp. alta' : 'Predisp.';
          li.appendChild(risk);
        }

        li.addEventListener('click', function() {
          state.answers.breed = b.name;
          state.answers.breedRisk = b.risk || '';
          state.answers.breedSizeHint = b.size || '';
          saveState();
          $$('.quiz-breed-item', list).forEach(function(o) { o.setAttribute('aria-pressed', 'false'); });
          this.setAttribute('aria-pressed', 'true');
          refreshNextButtonState();
          // NO auto-avance — el usuario pulsa "Siguiente"
        });
        list.appendChild(li);
      });
    }

    var searchDebounce;
    search.addEventListener('input', function() {
      clearTimeout(searchDebounce);
      var v = this.value;
      searchDebounce = setTimeout(function() { render(v); }, 100);
    });

    render('');
  }

  // ============================================================
  // STEP 7 — Email (opcional)
  // ============================================================
  function initStep7() {
    var step = $('.quiz-step[data-step="7"]');
    if (!step) return;
    var checkbox = $('.quiz-email-checkbox input', step);
    var input    = $('.quiz-email-block .quiz-input', step);
    if (!checkbox || !input) return;

    checkbox.checked = state.answers.emailOptIn;
    input.hidden = !state.answers.emailOptIn;
    input.value = state.answers.email || '';

    checkbox.addEventListener('change', function() {
      state.answers.emailOptIn = this.checked;
      input.hidden = !this.checked;
      if (!this.checked) state.answers.email = '';
      saveState();
      refreshNextButtonState();
    });

    input.addEventListener('input', function() {
      state.answers.email = this.value;
      saveState();
      refreshNextButtonState();
    });
  }

  // ============================================================
  // CÁLCULO DE ÁNGULO Y TALLA
  // ============================================================
  function calculateAngle() {
    var a = state.answers;
    // Multi-select: usar PRIMER problema seleccionado como ángulo principal
    var primaryProblem = a.problem || (a.problems && a.problems[0]) || '';
    var angleMap = {
      'diagnostico_reciente': 'ANG1',
      'cojera_cronica':        'ANG3',
      'lifestyle':             'ANG4',
      'post_cirugia':          'ANG5',
      'prevencion':            'ANG2'
    };
    var angulo = angleMap[primaryProblem] || 'DEFAULT';

    // Override 1 — ANG2 displasia: raza muy predispuesta + prevención
    if (a.breedRisk === 'very-high' && primaryProblem === 'prevencion') {
      angulo = 'ANG2';
    }

    // Override 2 — ANG6 perro senior: edad senior + prevención (sin raza muy predispuesta)
    if (a.age === 'senior' && primaryProblem === 'prevencion' && angulo !== 'ANG2') {
      angulo = 'ANG6';
    }

    // Override 3 — ANG6 perro senior: edad senior + lifestyle → emocional senior
    if (a.age === 'senior' && primaryProblem === 'lifestyle') {
      angulo = 'ANG6';
    }

    // Override 4 — ANG7 artrosis: cojera crónica + vet dio medicación (= condroprotectores)
    if (primaryProblem === 'cojera_cronica' && a.vet === 'say_meds') {
      angulo = 'ANG7';
    }

    return angulo;
  }

  function calculateSize() {
    var weight = state.answers.weight; // '1' a '5'
    var size = WEIGHT_TO_SIZE[weight];
    // Si la raza da hint distinto, usar promedio razonable.
    // Pero el peso del usuario es más fiable. Mantenemos size del peso.
    return size;
  }

  // ============================================================
  // FINAL — Redirect a PDP o Waitlist
  // ============================================================
  function finishQuiz() {
    var angulo = calculateAngle();
    var size = calculateSize();
    var inStock = IN_STOCK_SIZES.indexOf(size) !== -1;

    QuizTracker.track('quiz_completed', {
      angulo: angulo,
      talla: size,
      in_stock: inStock,
      dog_name: state.answers.dogName,
      dog_age: state.answers.age,
      dog_breed: state.answers.breed,
      dog_weight_bucket: state.answers.weight,
      problem: state.answers.problem,
      vet: state.answers.vet,
      email_opt_in: state.answers.emailOptIn,
      has_email: !!state.answers.email,
      // PLAN B Klaviyo: enviamos email plano solo si opt-in para que Apps Script lo forwardee a Klaviyo server-side
      email: (state.answers.emailOptIn && state.answers.email) ? state.answers.email : '',
      total_time_s: state.startedAt ? Math.round((Date.now() - state.startedAt) / 1000) : null
    });

    showLoading();

    setTimeout(function() {
      if (inStock) {
        redirectToPDP(angulo, size);
      } else {
        showWaitlist(size, angulo);
      }
    }, 1100);
  }

  function showLoading() {
    $$('.quiz-step').forEach(function(s) { s.setAttribute('data-active', 'false'); });
    $$('.quiz-intro').forEach(function(s) { s.setAttribute('data-active', 'false'); s.style.display = 'none'; });
    var loading = $('.quiz-loading');
    if (!loading) return;
    loading.setAttribute('data-active', 'true');
    var name = state.answers.dogName || 'tu perro';
    var statusEl = $('.quiz-loading__status', loading);
    var barEl = $('.quiz-loading__bar-fill', loading);
    var matchEl = $('.quiz-loading__match', loading);

    // Mejora 4: progreso animado con mensajes de estado
    var steps = [
      { pct: 18, msg: 'Analizando datos de ' + name + '...' },
      { pct: 38, msg: 'Cruzando raza con base de datos veterinaria...' },
      { pct: 60, msg: 'Detectando ángulo de tratamiento óptimo...' },
      { pct: 82, msg: 'Calculando talla exacta del arnés...' },
      { pct: 100, msg: '¡Plan listo!' }
    ];
    var i = 0;
    function tick() {
      if (i >= steps.length) return;
      var s = steps[i++];
      if (barEl) barEl.style.width = s.pct + '%';
      if (statusEl) statusEl.textContent = s.msg;
      if (s.pct === 100 && matchEl) {
        matchEl.removeAttribute('hidden');
      }
      setTimeout(tick, 220);
    }
    tick();
  }

  // MEJORA: overlay full-screen para evitar flash de PDP original durante redirect
  function showTransitionOverlay() {
    var name = state.answers.dogName || 'tu perro';
    var overlay = document.createElement('div');
    overlay.id = 'quiz-transition-overlay';
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'background:#FAF7F4',
      'display:flex', 'flex-direction:column', 'align-items:center',
      'justify-content:center', 'z-index:2147483647',
      'font-family:Poppins,Harmonia Sans,system-ui,sans-serif',
      'color:#0F172A', 'text-align:center', 'padding:20px'
    ].join(';');
    overlay.innerHTML =
      '<div style="font-size:56px;line-height:1;margin-bottom:18px;animation:qz-pawW 1.6s ease-in-out infinite">🐾</div>' +
      '<div style="font-size:20px;font-weight:700;margin-bottom:6px">Cargando el plan de ' + escapeHtml(name) + '...</div>' +
      '<div style="font-size:14px;color:#6B7280">Un segundo</div>' +
      '<style>@keyframes qz-pawW{0%,100%{transform:rotate(-8deg)}50%{transform:rotate(8deg)}}</style>';
    document.body.appendChild(overlay);
  }

  function redirectToPDP(angulo, size) {
    var weightBucket = state.answers.weight;
    var weightLabelMap = {
      '2': '12-22',
      '3': '22-40',
      '4': '40-55'
    };
    var pesoParam = weightLabelMap[weightBucket] || '';

    var productHandle = $('.quiz-flow').getAttribute('data-product-handle') || 'rodillera-para-la-pata-trasera-de-tu-perro';

    var url = '/products/' + productHandle + '?view=quiz-result' +
      '&angulo=' + encodeURIComponent(angulo) +
      '&nombre=' + encodeURIComponent(state.answers.dogName) +
      '&raza='   + encodeURIComponent(state.answers.breed) +
      '&peso='   + encodeURIComponent(pesoParam) +
      '&talla='  + encodeURIComponent(size) +
      '&sid='    + encodeURIComponent(QuizTracker.sessionId);

    // Si hay email opt-in, lo guardamos como Shopify Customer antes de redirect
    if (state.answers.emailOptIn && state.answers.email) {
      submitQuizLead(state.answers.email, ['quiz-lead-' + angulo, 'dog-' + slugify(state.answers.breed)]);
    }

    // Y arrastrar UTMs si las tenemos en sessionStorage
    var utms = QuizTracker.utms || {};
    Object.keys(utms).forEach(function(k) {
      if (utms[k]) url += '&' + k + '=' + encodeURIComponent(utms[k]);
    });

    // Limpiar estado para que la próxima visita empiece desde el principio
    clearState();

    // Overlay full-screen para evitar flash de PDP original durante redirect
    showTransitionOverlay();

    window.location.href = url;
  }

  function showWaitlist(size, angulo) {
    var quizContent = $('.quiz-flow__inner');
    var waitlist = document.getElementById('quiz-waitlist-block');
    if (quizContent) quizContent.style.display = 'none';
    if (waitlist) {
      waitlist.removeAttribute('hidden');
      // Personalizar
      var titleEl = $('.quiz-waitlist__title', waitlist);
      var subtitleEl = $('.quiz-waitlist__subtitle', waitlist);
      var name = state.answers.dogName || 'tu perro';
      if (titleEl) {
        titleEl.innerHTML = 'Aún no tenemos talla <em>' + size + '</em> para ' + escapeHtml(name) + '.';
      }
      if (subtitleEl) {
        var msg = (size === 'XS')
          ? 'Estamos fabricando la talla XS para perros de menos de 12 kg. Saldrá en unas semanas. Te avisaremos en cuanto esté disponible.'
          : 'Estamos fabricando la talla XL para perros de más de 55 kg. Saldrá en unas semanas. Te avisaremos en cuanto esté disponible.';
        subtitleEl.textContent = msg;
      }

      waitlist.setAttribute('data-size-needed', size);
      waitlist.setAttribute('data-angulo', angulo);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    QuizTracker.track('quiz_waitlist_shown', {
      size_needed: size,
      angulo: angulo,
      dog_name: state.answers.dogName,
      dog_breed: state.answers.breed
    });
  }

  function slugify(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  // ============================================================
  // SHOPIFY CUSTOMER CREATION (sin app)
  // ============================================================
  /**
   * Crea/identifica el customer en Klaviyo (si está) Y como Shopify Customer.
   * Klaviyo se usa para los WAITLIST (vamos a mandarles email cuando llegue stock).
   * Shopify Customer se usa para tagging de quiz leads.
   */
  function submitQuizLead(email, tags) {
    // 1. Klaviyo (si está cargado)
    if (window._learnq) {
      try {
        _learnq.push(['identify', {
          '$email': email,
          'DogName': state.answers.dogName,
          'DogBreed': state.answers.breed,
          'QuizAngulo': calculateAngle(),
          'QuizSize': calculateSize(),
          'QuizCompletedAt': new Date().toISOString()
        }]);
        _learnq.push(['track', 'Quiz Completed', {
          Angulo: calculateAngle(),
          Size: calculateSize(),
          DogName: state.answers.dogName,
          DogBreed: state.answers.breed
        }]);
      } catch (e) {}
    }

    // 2. Shopify Customer creation vía hidden form POST a /account/recover
    // (truco standard sin necesidad de password — crea el lead como recover-password-attempt)
    // Si el email no existe: Shopify genera un customer prospect
    // Si existe: actualiza tags
    // El POST se hace en background, no bloquea el redirect.
    var fd = new FormData();
    fd.append('form_type', 'recover_customer_password');
    fd.append('utf8', '✓');
    fd.append('email', email);
    fetch('/account/recover', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      keepalive: true
    }).catch(function() {});

    // 3. Tracking del envío
    QuizTracker.track('quiz_email_submitted_lead', {
      email_hash: hashEmail(email),
      tags: (tags || []).join(','),
      angulo: calculateAngle()
    });
  }

  function submitWaitlistEmail(email, sizeNeeded, angulo) {
    if (window._learnq) {
      try {
        _learnq.push(['identify', {
          '$email': email,
          'DogName': state.answers.dogName,
          'DogBreed': state.answers.breed,
          'WaitlistSize': sizeNeeded,
          'QuizAngulo': angulo
        }]);
        _learnq.push(['track', 'Joined Waitlist', {
          Size: sizeNeeded,
          DogName: state.answers.dogName,
          DogBreed: state.answers.breed,
          Source: 'Quiz'
        }]);
      } catch (e) {}
    }
    var fd = new FormData();
    fd.append('form_type', 'recover_customer_password');
    fd.append('utf8', '✓');
    fd.append('email', email);
    fetch('/account/recover', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      keepalive: true
    }).catch(function() {});

    QuizTracker.track('quiz_waitlist_submitted', {
      email_hash: hashEmail(email),
      // PLAN B Klaviyo: email plano para que Apps Script lo forwardee
      email: email,
      size_needed: sizeNeeded,
      angulo: angulo,
      dog_name: state.answers.dogName,
      dog_breed: state.answers.breed
    });
  }

  function hashEmail(email) {
    var s = (email || '').toLowerCase();
    var h = 0;
    for (var i = 0; i < s.length; i++) {
      h = ((h << 5) - h) + s.charCodeAt(i);
      h |= 0;
    }
    return 'h' + (h >>> 0).toString(36);
  }

  // ============================================================
  // WAITLIST FORM HANDLER
  // ============================================================
  // ============================================================
  // MEJORA 7 — Contador dinámico "X personas han hecho este test hoy"
  // Crece a lo largo del día. Determinista (no random) basado en hora.
  // ============================================================
  function initCounter() {
    var el = document.getElementById('quiz-counter-today');
    if (!el) return;
    var now = new Date();
    var hour = now.getHours();
    // De 0h a 23h, contador va de 8 a 84 (curva natural)
    var base = Math.floor(8 + (hour * 76 / 23));
    // Pequeña variación pseudo-random pero determinista (día + minuto)
    var seed = (now.getDate() * 60 + now.getMinutes()) % 7;
    var n = base + seed;
    el.textContent = n;

    // Incrementa cada 60-180s mientras esté abierta la pestaña
    setInterval(function() {
      if (document.hidden) return;
      var cur = parseInt(el.textContent, 10) || n;
      if (cur < 200) el.textContent = cur + 1;
    }, 60000 + Math.random() * 120000);
  }

  function initWaitlist() {
    var form = $('.quiz-waitlist__form');
    if (!form) return;
    form.addEventListener('submit', function(ev) {
      ev.preventDefault();
      var input = $('input[type="email"]', form);
      var email = input ? input.value.trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (input) input.focus();
        return;
      }
      var waitlist = document.getElementById('quiz-waitlist-block');
      var sizeNeeded = waitlist ? waitlist.getAttribute('data-size-needed') : '';
      var angulo = waitlist ? waitlist.getAttribute('data-angulo') : '';

      submitWaitlistEmail(email, sizeNeeded, angulo);

      // Mostrar mensaje de éxito
      form.style.display = 'none';
      var success = $('.quiz-waitlist__success', waitlist);
      if (success) success.removeAttribute('hidden');
      clearState();
    });

    var skip = $('.quiz-waitlist__skip');
    if (skip) {
      skip.addEventListener('click', function() {
        QuizTracker.track('quiz_waitlist_skipped', {
          size_needed: document.getElementById('quiz-waitlist-block').getAttribute('data-size-needed')
        });
        // Redirigir a PDP original (no a home) — todavía hay chance de conversión
        var handle = (document.querySelector('.quiz-flow') || {}).dataset
          ? document.querySelector('.quiz-flow').dataset.productHandle
          : 'rodillera-para-la-pata-trasera-de-tu-perro';
        window.location.href = '/products/' + (handle || 'rodillera-para-la-pata-trasera-de-tu-perro');
      });
    }
  }

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    // Botón "Empezar test" (intro)
    var introCta = $('.quiz-intro__cta');
    if (introCta) {
      introCta.addEventListener('click', function(e) {
        e.preventDefault();
        if (!state.startedAt) state.startedAt = Date.now();
        QuizTracker.track('quiz_started', {});
        showStep(1);
      });
    }

    // Botón Atrás
    var backBtn = $('.quiz-progress__back');
    if (backBtn) backBtn.addEventListener('click', goBack);

    // Botones Next por paso
    $$('.quiz-next').forEach(function(btn) {
      btn.addEventListener('click', function() { goNext(); });
    });

    // Enter en inputs → goNext
    $$('.quiz-input').forEach(function(input) {
      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (isCurrentStepValid()) goNext();
        }
      });
    });

    initStep1();
    initStep3();
    initOptionButtons();
    initStep7();
    initWaitlist();
    initCounter();

    // Restaurar paso anterior si hay state guardado
    var resumeFrom = state.currentStep;
    if (resumeFrom > 0 && resumeFrom <= TOTAL_STEPS && state.startedAt) {
      showStep(resumeFrom);
    } else {
      showStep(0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
